import { supabase } from '../supabaseClient'

const USE_DEV_PROXY =
  process.env.NODE_ENV === 'development' &&
  typeof window !== 'undefined' &&
  /^https?:\/\/localhost(:\d+)?$/i.test(window.location.origin)

async function extrairErroEdgeFunction(error, data) {
  if (data?.error) {
    return typeof data.error === 'string' ? data.error : String(data.error)
  }
  try {
    if (error?.context && typeof error.context.json === 'function') {
      const body = await error.context.json()
      if (body?.error) return typeof body.error === 'string' ? body.error : String(body.error)
    }
  } catch (_) {
    /* ignore */
  }
  const msg = error?.message || ''
  if (msg && !msg.includes('non-2xx')) return msg
  return 'Falha ao enviar e-mail. Verifique RESEND_API_KEY, RESEND_FROM_EMAIL, SITE_URL e o deploy de send-password-reset.'
}

async function invokePasswordReset(email) {
  const body = { email: String(email).trim().toLowerCase() }

  if (USE_DEV_PROXY) {
    const res = await fetch('/api/send-password-reset', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
      return { data, error: { message: data?.error || `HTTP ${res.status}` } }
    }
    return { data, error: null }
  }

  return supabase.functions.invoke('send-password-reset', { body })
}

export async function solicitarRecuperacaoSenha(email) {
  try {
    const { data, error } = await invokePasswordReset(email)

    if (data?.ok === false && data?.error) {
      return { success: false, error: data.error }
    }
    if (error) {
      const msg = await extrairErroEdgeFunction(error, data)
      return { success: false, error: msg }
    }
    return {
      success: true,
      message:
        data?.message ||
        'Se o e-mail estiver cadastrado, você receberá as instruções para redefinir sua senha em instantes.'
    }
  } catch (e) {
    console.error('[Recuperação senha]', e)
    return { success: false, error: (e && e.message) || 'Erro ao enviar solicitação.' }
  }
}

export async function redefinirSenhaComToken(token, novaSenha) {
  try {
    const { data, error } = await supabase.rpc('redefinir_senha_por_token', {
      p_token: token,
      p_nova_senha: novaSenha
    })

    if (error) {
      return { success: false, error: error.message }
    }

    const resultado = Array.isArray(data) ? data[0] : data
    if (resultado?.sucesso) {
      return { success: true, message: resultado.mensagem || 'Senha redefinida com sucesso.' }
    }
    return { success: false, error: resultado?.mensagem || 'Não foi possível redefinir a senha.' }
  } catch (e) {
    console.error('[Redefinir senha]', e)
    return { success: false, error: (e && e.message) || 'Erro ao redefinir senha.' }
  }
}
